import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getItemStorage } from "../Localstorage/useLocalStorage";

// context
import { UserData } from "../contexts/UserInfoContext";
import AuthContext from "../contexts/authContext";

// components
import Loading from "../components/shared/Loading";

const ProtectedRoutes = () => {
  const { user, userLoaded } = useContext(UserData);
  const [loading, setLoading] = useState(true);

  const [isAuth, setIsAuth] = useState(null);

  const token = getItemStorage("token");

  useEffect(() => {
    if (token) {
      if (userLoaded) {
        if (user.user?.id) {
          setIsAuth(true);
          setLoading(false);
        } else {
          setIsAuth(false);
          setLoading(false);
        }
      }
    } else {
      setIsAuth(false);
    }
  }, [token, isAuth, user, userLoaded, loading]);

  if (isAuth !== null) {
    if (isAuth) {
      return <Outlet />;
    } else if (!isAuth && user?.user?.role === 2) {
      return <Navigate to="/admin" />;
    } else {
      return <Navigate to="/auth" />;
    }
  } else if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Loading />
      </div>
    );
  }
};

export default ProtectedRoutes;
